// About-page content data. Phase 5 — refocused on founder Rusty White; the
// former plural-team block was retired here so the story reads with a single
// authorial voice. `we / our` remains free to describe the wider craftsmen
// team that ACT deploys on-site.

export const FOUNDER = {
    name: "Rusty White",
    title: "Founder & Principal Systems Designer",
    alt: "Rusty White, Founder & Principal Systems Designer, Advanced Connected Technologies",
    credentials: [
        "U.S. Army Reserves · Staff Sergeant · Squad Leader",
        "Founder & Principal Systems Designer",
    ],
    // Each paragraph optionally flags an `emphasis: true` variant — that
    // one is rendered as an editorial italic pull-line in the middle of
    // the bio, not as body copy.
    bio: [
        {
            text:
                "Rusty founded Advanced Connected Technologies to bring military-grade discipline to residential technology. After a decade of service — and still an active Staff Sergeant and Squad Leader in the U.S. Army Reserves — he learned that in the field, small details are the difference between a mission that succeeds and one that fails. He carries that standard into every installation ACT touches.",
        },
        {
            text:
                "He founded ACT after seeing a gap in the luxury market: too many integrators promising the world and delivering unfinished work, unreliable networks, and cables run without care. Rusty's clients — service members, executives, architects, and high-net-worth families — expect systems that simply work, every day, for decades. That's the bar he holds his craftsmen to, and the reason ACT exists.",
        },
        {
            emphasis: true,
            text:
                "Every wire is dressed. Every rack is labeled. Every home is tested three times before we hand it over.",
        },
        {
            text:
                "When Rusty isn't in the field with his unit or on-site with a client, he's refining the process — writing checklists, auditing installs, and setting the tone for a team that treats a home like an operational asset.",
        },
    ],
    quote:
        "I built ACT because I was tired of watching integrators walk off unfinished jobs. The bar should be simple — the best technology in a luxury home is invisible. If you notice it, we did it wrong.",
    schemaDescription:
        "Founder of Advanced Connected Technologies and active Staff Sergeant in the U.S. Army Reserves. 10 years of military service. Focused on bringing military-grade discipline and attention to detail to luxury residential technology.",
};

export const CREDENTIALS = [
    "Control4 Pinnacle Dealer",
    "Savant Elite Integrator",
    "Lutron Platinum Preferred",
    "CEDIA Certified Designer",
    "THX Certified Professional",
    "ISF Certified Calibrator",
    "Access Networks Elite Partner",
];

export const STANDARDS = [
    {
        title: "Discretion",
        copy:
            "We work under NDA from first conversation. Every project is confidential, every household private, every conversation between us protected.",
    },
    {
        title: "Craft",
        copy:
            "Cable management, panel finishing, software configuration — every layer of the work is held to the same standard the architect held the stone.",
    },
    {
        title: "Longevity",
        copy:
            "We specify systems that age gracefully and maintain firmware stewardship across a residence's life. Every installation is engineered to remain in quiet service, season after season.",
    },
    {
        title: "Partnership",
        copy:
            "We are not subcontractors. We are a named partner to the architect, designer, and household — present from blueprint through the seasons that follow.",
    },
];

export const ABOUT_STORY = {
    paragraph1:
        "Advanced Connected Technologies was founded on a single conviction: that the integration practice serving the most considered residences in the world deserves to operate at the same level of craft as the architects, interior designers, and millworkers it works alongside. The studio was built around that conviction from day one — small teams, written specifications, calibrated rooms, and a service partnership that lasts as long as the residence does.",
    paragraph2:
        "Today the studio works across the United States and selectively abroad, in close collaboration with the design firms whose work we respect most. We remain deliberately small. Every engagement is led by a principal of the firm; every household has a named concierge. We are particular about the homes we accept and the partners we keep — and we ask the same particularity, in return, of the homes that find us.",
    pullquote:
        "We are not in the business of selling devices. We are in the business of authoring how a home behaves.",
};
